import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'
import Auth from '@/model/Auth'
import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import Snotify from 'vue-snotify'

Vue.use(VueProgressBar)
Vue.use(Auth)
window.swal = require('sweetalert2')

Vue.use(Datetime)
Vue.use(Snotify)

// Files that requires more configuration
require('./bootstrap/fontAwesome')
require('./bootstrap/axios')
require('./bootstrap/validator')
require('./bootstrap/quill')
require('./bootstrap/filters')



// WEBPACK FOOTER //
// ./src/bootstrap.js